import { useState } from 'react';

export const useWhatsAppForm = (phoneNumber = '+916377733291') => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const sendToWhatsApp = (formData) => {
    const message = `New Contact Form Submission:\n\n` +
      `Name: ${formData.name}\n` +
      `Email: ${formData.email}\n` +
      `Phone: ${formData.phone}\n` +
      `Message: ${formData.message}`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber.replace(/[^0-9]/g, '')}?text=${encodedMessage}`;

    window.open(whatsappUrl, '_blank');
  };

  return { sendToWhatsApp, isSubmitting, setIsSubmitting };
};
